import React from 'react';
import { Field, RichTextField } from '@sitecore-jss/sitecore-jss-nextjs';
import { TextAccordion } from '@ahc-digital/component-library';
import { CreateC02AccordionViewMoreModel } from './C02AccordionViewMore.service';
import { PromptForMissingDatasource } from 'src/shared/PromptForMissingDatasource';
import {
  AnchorTargetParams,
  DynamicPlaceholderParams,
  RenderingProps,
  TranslationOptionsParams,
} from 'src/shared/shared.types';
import { translationClasses } from 'src/shared/TranslationClasses';
import { useCreateMarketingRenderingHame } from 'src/shared/useCreateMarketingRenderingName';

export type C02AccordionViewMoreProps = RenderingProps<
  C02AccordionViewMoreFields,
  C02AccordionViewMoreRenderingPramas
>;

export type C02AccordionViewMoreFields = {
  Title?: Field<string>;
  AlwaysVisibleText?: RichTextField;
  HiddenText?: RichTextField;
};

export type C02AccordionViewMoreRenderingPramas = {
  TitleAlignment?: string;
  TitleType?: string;
  BodyCopyAlignment?: string;
} & DynamicPlaceholderParams &
  TranslationOptionsParams &
  AnchorTargetParams;

export const Default = (props?: C02AccordionViewMoreProps): JSX.Element => {
  const marketingRenderingName = useCreateMarketingRenderingHame(
    props?.rendering?.componentName as string
  );

  if (!props?.rendering?.dataSource)
    return <PromptForMissingDatasource rendering={props?.rendering} />;

  return (
    <TextAccordion
      className={translationClasses(props?.params)}
      id={props?.params?.AnchorLinkTargetName}
      data-component={marketingRenderingName}
      {...CreateC02AccordionViewMoreModel(props)}
    />
  );
};
